<template>
    <div class="animated fadeIn">
      <b-breadcrumb><strong>Add Min Max Values For Grade</strong></b-breadcrumb>
  
      <div class="design-container-details__main p-5">
          <div class="col-md-12 ">
              
            <div class="row">

                <table class="responsive-table">
                    <thead >
                        <tr>
                        <th>Grade</th>
                        <th>Min Value</th>
                        <th>Max Value</th>
                        <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(grade, index) in grades" :key="grade.name">
                        <td>{{ grade.grade }}</td>
                        <td>
                            <div class="cell-content">
                            <input min="0"
                                type="number"
                                v-model="grade.min"
                                class="input-field"
                                :disabled="!grade.isEditing"
                            />
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                            <input min="0"
                                type="number"
                                v-model="grade.max"
                                class="input-field"
                                :disabled="!grade.isEditing"
                            />
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                            <button @click="editGrade(index)" :disabled="grade.isEditing" class="btn btn-primary ml-2">Edit</button>
                            <button @click="submitGrade(index)" :disabled="!grade.isEditing" class="btn btn-success ml-2">Submit</button>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
        
            </div>
  
          </div>
  
      </div>
    </div>
  
  
  
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import auth from "@/utils/auth";
  import Vue from "vue";
  import Utils from "@/utils";
  import { ToggleButton } from "vue-js-toggle-button";
  import Datepicker from "vuejs-datepicker";
  Vue.component("ToggleButton", ToggleButton);
  // import auth from "@/utils/auth";
  
  import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
  import Table from "../views/base/Table.vue";
  
  const axios = require("axios");
  export default {
    name: "grade_minmax",
    components: {
      sidebarSettingsComponent,
      Table,
   
    },
    data() {
       return {
        grades: [
        { grade: 'A+', min: '', max: '', isEditing: false },
        { grade: 'A', min: '', max: '', isEditing: false },
        { grade: 'B+', min: '', max: '', isEditing: false },
        { grade: 'B', min: '', max: '', isEditing: false },
        { grade: 'C+', min: '', max: '', isEditing: false },
        { grade: 'C', min: '', max: '', isEditing: false },
        { grade: 'D', min: '', max: '', isEditing: false },
      ],

      user_type:'',
       
      };
    },
  
      created: function() {
          var userData = localStorage.getItem("userData");
          var userInfo = JSON.parse(userData);
          this.user_type = userInfo[0].user_type;
        this.gradelisting();
    },
  
  
    methods:{

        editGrade(index) {
      this.grades[index].isEditing = true;
    },
    submitGrade(index) {
      this.grades[index].isEditing = false;
      // You can add your submit logic here
      console.log(`Grade ${this.grades[index].grade} updated:`, this.grades[index]);
      const grade = this.grades[index];
      if (grade.min < grade.max) {
        console.log(`Grade ${grade.name} updated:`, grade);

        const obj ={
            grade:grade.grade,
            min:grade.min,
            max:grade.max,
            created_by: this.user_type
        }

        console.log("objobj", obj)
        document.getElementById("overlay").style.display = "block";
        axios
        .post(`${CONSTANTS.API_URL}/gradeinsert`, obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg === "Successful") {
            this.$fire({
                text: response.data.returnvalue,
                type: "success",
                timer: 30000,
              });
            this.gradelisting();
          } else {

            this.$fire({
                text: response.data.returnvalue,
                type: "Error",
                timer: 30000,
              });
        
          }
        })

      } else {
        alert('Max value must be greater than Min value.');
      }

    },

    gradelisting(){
        axios
        .post(`${CONSTANTS.API_URL}/gradelisting`, {})
        .then((response) => {
            if (response.data.returnmsg === "Successful") {
                console.log("response.data.returnvalue", response.data.returnvalue)
                this.updateGrades(response.data.returnvalue);
            }

        })

    },
    
    updateGrades(data) {
      const apiGrades = data.map(item => ({
        grade: item.grade,
        min: Number(item.min),
        max: Number(item.max),
        isEditing: false
      }));

      const existingGrades = this.grades.filter(grade => !apiGrades.some(apiGrade => apiGrade.grade === grade.grade));

      this.grades = [...apiGrades, ...existingGrades];
    },

    }
  };
  </script>

  
  
  